import { ChangeDetectorRef, Component } from "@angular/core";
import { PanelService } from "@sharedV11/services/panel/panel.service";
import { SuperClassComponent } from "@sharedV11/super-class-edit/super-class/super-class.component";
import { EditTpvsComponent } from "./edit-tpvs/edit-tpvs.component";

@Component({
  selector: "app-tpvs",
  templateUrl: "./tpvs.component.html",
  styleUrls: ["./tpvs.component.scss"],
})
export class TpvsComponent extends SuperClassComponent {
  constructor(
    protected panelService: PanelService,
    protected cdRef: ChangeDetectorRef
  ) {
    super(panelService, cdRef);
  }
  openPanel() {
    this.customanpanel = EditTpvsComponent;
    this.editChangeCss();
    this.cdRef.detectChanges();
  }
}
